export enum PrintType{
    List = 'list',
    Document = 'document',
    FilteredList = 'filteredlist'
}